// Message names and the build fingerprint shared by the page and the worker.
//
// A leaf module on purpose: `service-worker.ts` is compiled as a worker bundle,
// so anything it imports must not drag the app (or posthog) in with it. The
// page-side half of this lives in `modules/appUpdate`.

/** Page → waiting worker: "which build are you?" (reply on the message port). */
export const GET_BUILD = 'GET_BUILD'

/** Waiting worker → page: the answer. */
export const BUILD_ID = 'BUILD_ID'

export type BuildIdMessage = { type: typeof BUILD_ID; buildId: string }

type ManifestEntry = string | { url: string; revision?: string | null }

/**
 * A fingerprint of the build a worker was compiled for.
 *
 * `index.html` is the one precached file whose name never changes and whose
 * contents change on every build (it carries the hashed bundle names), so
 * Workbox always gives it a revision — that revision IS the build. Everything
 * under `/static/` is content-hashed into its filename instead and has
 * `revision: null`, which is why they are no use here.
 *
 * Empty string when the manifest has no such entry: the caller must treat that
 * as "unknown", never as "same build".
 */
export const readBuildId = (manifest: ReadonlyArray<ManifestEntry>): string => {
    for (const entry of manifest) {
        if (typeof entry === 'string') continue
        if (/(^|\/)index\.html$/.test(entry.url) && entry.revision) {
            return entry.revision
        }
    }
    return ''
}
